import React from 'react';
import CookieSettingsLink from '../common/CookieSettingsLink';
import { PRIVACY_URL, TERMS_URL } from '../../config/legal';

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();

    return (
        <footer className="bg-william-800 text-william-200">
            <div className="max-w-[1200px] mx-auto px-4 sm:px-6 lg:px-4">
                <div className="py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
                    <p className="text-xs text-william-400">
                        &copy; {currentYear} BasiQR. All rights reserved.
                    </p>
                    <div className="flex items-center gap-5">
                        <a
                            href={PRIVACY_URL}
                            className="text-xs text-william-400 hover:text-william-200 transition-colors rounded-sm"
                        >
                            Privacy Policy
                        </a>
                        <a
                            href={TERMS_URL}
                            className="text-xs text-william-400 hover:text-william-200 transition-colors rounded-sm"
                        >
                            Terms of Service
                        </a>
                        <CookieSettingsLink className="text-xs text-william-400 hover:text-william-200 transition-colors rounded-sm" />
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
